<template>
  <div>
    <custom-field
      v-for="filter in filters"
      :key="filter.key"
      :filter="filter"
      :value="filterValues[filter.key]"
      @input="handleFilterChange(filter.key, $event)"
    />
  </div>
</template>

<script>
import CustomField from "./CustomField.vue";

export default {
  name: "CustomFilterRenderer",
  components: {
    CustomField
  },
  props: {
    filters: {
      type: Array,
      required: true,
      default: () => []
    },
    initialValues: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      filterValues: {}
    };
  },
  computed: {
    hasActiveFilters() {
      return Object.values(this.filterValues).some(value => {
        if (Array.isArray(value)) {
          return value.length > 0;
        }
        if (typeof value === "object" && value !== null) {
          return value.min !== null || value.max !== null;
        }
        return value !== null && value !== false;
      });
    }
  },
  watch: {
    filters: {
      handler() {
        this.initializeFilterValues();
      },
      immediate: true
    },
    initialValues: {
      handler() {
        this.initializeFilterValues();
      },
      immediate: true
    }
  },
  methods: {
    initializeFilterValues() {
      this.filterValues = this.filters.reduce((acc, filter) => {
        // Usar valor inicial si existe, sino crear valor por defecto
        const initialValue = this.initialValues[filter.key];

        if (initialValue !== undefined) {
          acc[filter.key] = initialValue;
        } else {
          acc[filter.key] = this.getDefaultValue(filter);
        }

        return acc;
      }, {});
    },
    getDefaultValue(filter) {
      switch (filter.type) {
        case "string":
        case "array":
          return [];
        case "boolean":
          return false;
        case "number":
          return { min: null, max: null };
        default:
          return null;
      }
    },
    handleFilterChange(key, value) {
      this.filterValues[key] = value;
      this.$emit("update:customFields", { key, value });
    },
    clearAllFilters() {
      this.filterValues = this.filters.reduce((acc, filter) => {
        acc[filter.key] = this.getDefaultValue(filter);
        return acc;
      }, {});
      this.emitFilterChange();
    },
    emitFilterChange() {
      this.$emit("filter-change", this.filterValues);
    }
  }
};
</script>

<style scoped>
.v-chip {
  transition: all 0.2s ease;
}
</style>
